module.exports = __webpack_public_path__ + "static/img/pdarrow_left.4027748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdarrow_left.png
// module id = zC+x
// module chunks = 2